import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { BasicChaosGame, ChaosGame } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Chaos Game"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "chaos-game"
    }}>{`Chaos Game`}</h1>
    <BasicChaosGame mdxType="BasicChaosGame" />
    <p>{`The `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Chaos_game"
      }}>{`Chaos Game`}</a>{` is a method to generate a fractal.`}</p>
    <p>{`We start from an equilateral triangle, and one point chosen at random in the plane.
At each iteration, we plot a new point which is halfway between the previous point, and one of the vertices of the triangle, chosen at random.
We continue plot points like these.`}</p>
    <p>{`Eventually, our figure looks like the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Sierpi%C5%84ski_triangle"
      }}>{`Sierpiński triangle`}</a></p>
    <ChaosGame mdxType="ChaosGame" />
    <p>{`But we can generalize this to other polygons.
In this second version, we can choose a regular polygon with 3 to 12 vertices (so, anything from a triangle to a dodecagon).
We can also choose whether we use each vertex as an attractor or not. If a vertex is not an attractor, it won't be used to compute the position of new points in iterations.`}</p>
    <p>{`For larger polygons, if all vertices are used as attractors, the resulting figure looks a bit messy. But if we only pick a few, then shapes will start to emerge.`}</p>
    <p>{`One interesting pattern is for polygons with odd number of vertices, if vertices = 2 x n + 3.
You can try:`}</p>
    <ul>
      <li parentName="ul">{`set the first vertex,`}</li>
      <li parentName="ul">{`leave n vertices unset,`}</li>
      <li parentName="ul">{`set the next 2 vertices,`}</li>
      <li parentName="ul">{`leave the last n vertices unset.`}</li>
    </ul>
    <p>{`So: 1 0 1 1 0 for 5, 1 0 0 1 1 0 0 for 7, 1 0 0 0 1 1 0 0 0 for 9, etc.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      